/**
 * Shared boot-skeleton helpers.
 * Sidebar collapsed pref matches Sidebar.jsx (`getItem("sidebarCollapsed", true)`).
 */

/** Read saved sidebar collapsed preference. */
export function readSidebarCollapsedPref(getItem) {
  try {
    return Boolean(getItem?.("sidebarCollapsed", true));
  } catch {
    return false;
  }
}

export const BOOT_SIDEBAR_LINK_COUNT = 11;
export const BOOT_SIDEBAR_LABEL_WIDTHS = [
  120, 90, 110, 100, 130, 95, 105, 80, 115, 125, 92,
];

/** Desktop navbar action tiles (theme, customize, notifications, etc.). */
export const BOOT_NAVBAR_ICON_COUNT = 7;
